export var mainMappingKey = 'main-mapping';
export var mainMappingVariable = "{{".concat(mainMappingKey, "}}");
//# sourceMappingURL=main-mapping-pattern.js.map